// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2cGqA","notes":"Notes_notes__2Lfia"};